import React from 'react';

import { IPositionWithCandidates } from '@types';
import { awaitsReader } from '@utils';
import { ICandidatesControls } from '../controls';
import { CandidateFiltersDialog } from './CandidateFiltersDialog';
import { ListHeader } from './ListHeader';

interface ICandidatesHeaderProps {
  positions: IPositionWithCandidates[];
  controls?: ICandidatesControls;
  title?: string;
}

export const CandidatesHeader: React.FC<ICandidatesHeaderProps> = ({
  positions,
  controls,
  title = 'Candidates for your positions',
}) => {
  const candidates = positions.flatMap((position) => position.candidates ?? []);
  const waitingCount = candidates.filter((candidate) =>
    awaitsReader(candidate),
  ).length;

  return (
    <ListHeader
      title={title}
      filtersDialog={controls && <CandidateFiltersDialog {...controls} />}
      summary={
        candidates.length > 0 && (
          <>
            {candidates.length} shown
            {waitingCount > 0 && ` · ${waitingCount} waiting on you`}
          </>
        )
      }
    />
  );
};
